import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-vri",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-vri.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-vri.component.less",
})
export class PrefixVriComponent extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 50;
    this.characters = ALLOWED_CHARACTERS["vri"];
  }
}
